module.exports = __webpack_public_path__ + "img/python.c68c4623.svg";